import { Separator } from "@/components/ui/separator";
import { Dot, EllipsisVertical, User, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { toast } from "react-hot-toast";
import useAuth from "@/hooks/useAuth";
import { createBookingTable, createRoom, createTable, getAllRooms, getAllRoomsWithoutPagination, getAllTablesWithRoom, quickBookingTable, swapTable, updateRoom, updateTable } from "@/api/table-floor/tableFloor";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllTables } from "@/redux/slice/table-slice/table-slice";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { getAllStaff } from "@/api/staff";
import { restaurant_id } from "@/api/lib/url";

const addNewFloorCardSchema = z.object({
  floor_id: z.number().min(1, "Floor is required"),
  room_id: z.number().min(1, "Room is required"),
  table_id: z.number().min(1, "Table is required"),
});

const SwapTableModal = ({ isOpen, onClose, swapBookingId, itemsDialog }) => {
  
  const { tables, floors, selectedFloor, selectedRoom } = useSelector(
    (state) => state.table.table
  );
  const [loading, setLoading] = useState(false);
  const [showIsChild, setShowIsChild] = useState(false);
  const { user } = useAuth();
  const [customer, setCustomer] = useState([])
  const [rooms, setRooms] = useState([])
  // const [tables, setTables] = useState([])
  // console.log(customer);
  // console.log(rooms);
  
  const formatTime = (time) => {
    if (!time) return "-";
    const [h, m] = time.split(":");
    const date = new Date();
    date.setHours(h, m);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  
  const dispatch = useDispatch();  

  const form = useForm({
    resolver: zodResolver(addNewFloorCardSchema),
    mode: "onChange",
    defaultValues: {
      floor_id: "",
      room_id: "",
      table_id: "",
    },
  });

  const floorId = form.watch("floor_id");
  useEffect(() => {
    if(floorId){
      getAllRoomsWithoutPagination(user?.restaurant_id, floorId)
        .then((res) => {
          if (res.status === "success") {
            setRooms(res.data.rooms);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [floorId]);

  const roomId = form.watch("room_id");
  useEffect(() => {
    if(roomId){
      // getAllTablesWithRoom(roomId)
      //   .then((res) => {
      //     if (res.status === "success") {
      //       setTables(res.data.tables);
      //     }
      //   })
      //   .catch((err) => console.log(err));
      dispatch(fetchAllTables(Number(roomId)));
    }
  }, [roomId]);

  const { reset } = form;
  const addFloorCardData = async (data) => {
    // console.log(form.error())
    // console.log(data);
    // return;
    // console.log(data);
    
    setLoading(true);

    const payload =
      {
        ...data,
        restaurant_id: user.restaurant_id,
      };
// console.log(payload);
// return;

    try {
      let res;
      res = await swapTable(swapBookingId.id, payload);
      if (res.status === "success") {
        toast.success("Swap Table successfully!");
        
        onClose();
        reset();
        // IMPORTANT: refresh tables for selected room to reflect changes immediately
        if (data.room_id || selectedRoom?.id) {
          const roomId = data.room_id || selectedRoom?.id;
          dispatch(fetchAllTables(Number(roomId)));
        }
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    } catch (err) {
      toast.error(err?.message || "Failed to process Floor Card");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
        <Card className="bg-cblack4 text-cwhite w-[600px]  h-[90vh] overflow-scroll">
          <CardHeader className="flex flex-row justify-between items-center">
            <CardTitle className="text-cwhite text-xl font-medium">Swap Table</CardTitle>
            <X onClick={onClose} className="cursor-pointer" size={16} />
          </CardHeader>
          <Separator />
          <CardContent>
            <div>
              <div className="flex justify-between mt-6 bg-[#2f2f2f] p-4">
                <div className="flex">
                  <div className="text-center pr-2 border-r-2 border-white">
                    <p className="text-[14px] font-normal">{formatTime(swapBookingId.start_time)}</p>
                    <p className="text-[12px] text-gray-500 font-normal">to</p>
                    <p className="text-[14px] font-normal">
                      {formatTime(swapBookingId.end_time) || "-"}
                    </p>
                  </div>

                  <div className="text-[14px] font-normal flex flex-col justify-between pl-2">
                    <p>{swapBookingId?.customer_name || "Md Rasel Mahmud"}</p>
                    <p className="flex items-center">
                      <User size={16} className="mr-1" />
                      {swapBookingId?.guest || 0} <Dot /> £ {swapBookingId?.amount || "0.00"}
                    </p>
                  </div>
                </div>

                <div className="flex flex-col justify-between">
                  <div className="flex gap-1">
                    <p className="px-2.5 py-1 bg-[#383838]">Floor: {itemsDialog?.floor?.name}</p>
                    <p className="px-2.5 py-1 bg-[#383838]">Room: {itemsDialog?.room?.name}</p>
                  </div>
                  <p className="px-2.5 py-1 bg-[#383838] mt-1">Table: {itemsDialog?.name}</p>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <p className="text-base font-medium text-center mb-4">Enter Swap Table Details</p>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(addFloorCardData)} className="flex flex-col gap-5">
                  <FormInputField
                    name="floor_id"
                    style="bg-cblack3"
                    placeholder={"Select Floor"}
                    form={form}
                    type="select"
                    parseAs="string"
                    // selectOption={[
                    //   { label: "In Person", value: "in_person" },
                    //   { label: "Phone Call", value: "phone_call" },
                    //   { label: "Online", value: "online" },
                    // ]}
                    selectOption={floors?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Floor"}
                    required={true}
                  />
                  <FormInputField
                    name="room_id"
                    style="bg-cblack3"
                    placeholder={"Select Room"}
                    form={form}
                    type="select"
                    parseAs="string"
                    selectOption={rooms?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Room"}
                    required={true}
                  />
                  <FormInputField
                    name="table_id"
                    style="bg-cblack3"
                    placeholder={"Select Table"}
                    form={form}
                    type="select"
                    parseAs="string"
                    selectOption={tables?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Table"}
                    required={true}
                  />
                  <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">Number of Seats</label>
                  <input
                      className="flex h-9 w-full text-white rounded-md border border-gray-600 bg-transparent px-3 py-1 text-base shadow-sm transition-colors placeholder:text-cwhite3/70 focus-visible:outline-none cursor-not-allowed disabled:opacity-50 md:text-sm"
                      value={swapBookingId.guest}
                      readOnly
                  />
                  {/* <FormInputField style="bg-cblack3" placeholder={"Enter Number of Guest"} label={"Number Of Guest"}/> */}
                  <div className="mt-4 flex gap-5 w-full">
                    <Button className="w-full bg-cred text-white" onClick={onClose}>
                        Cancel
                    </Button>

                    <Button isLoading={loading} className="w-full bg-cyellow">
                        Confirm
                    </Button>
                  </div>
                </form>
              </Form>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default SwapTableModal;
